module.exports = __webpack_public_path__ + "static/antd-badge-count-d2dde2c86af964d7b6ef8daf75391478.png";